import AppearanceOptionState from './schema/AppearanceOptionState';
import { createStore } from 'satcheljs';

/**
 * Creates store which reflects the current state of settings under calendar appearance option
 */
export default createStore<AppearanceOptionState>('calendarAppearanceOption', {
    weekStartDay: null,
    timeIncrement: null,
    workDays: null,
    showWeekNumbers: null,
    firstWeekOfYear: null,
    workingHoursStartTime: null,
    workingHoursEndTime: null,
    workingHoursTimeZoneId: null,
});
